'use client'

import { useEffect, useState } from 'react'
import { useRouter, useSearchParams } from 'next/navigation'
import { setCookie } from 'cookies-next'
import { useAuthStore } from '@/lib/stores/auth-store'
import { useThemeStore } from '@/lib/stores/theme-store'
import { useVisitorStore } from '@/lib/stores/visitor-store'
import { isWhiteLabelDomain } from '@/lib/utils'
import {
  isVisitorAccessEnabled,
  VISITOR_COOKIE_MAX_AGE,
  VISITOR_MODE_COOKIE,
} from '@/lib/visitor-access'

/**
 * Quando o tema permite visitantes, redireciona da tela de login para a vitrine.
 * Fallback client-side para quando o proxy ainda não aplicou o cookie/redirect.
 */
export function useVisitorLoginRedirect() {
  const router = useRouter()
  const searchParams = useSearchParams()
  const { isAuthenticated, isLoading: isAuthLoading } = useAuthStore()
  const { currentTheme, isInitialized: isThemeInitialized } = useThemeStore()
  const { setVisitorMode } = useVisitorStore()
  const [isRedirecting, setIsRedirecting] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined') return
    if (!isWhiteLabelDomain(window.location.hostname)) return
    if (!isThemeInitialized || isAuthLoading) return
    if (isAuthenticated) return

    const forceLogin = searchParams.get('force_login') === '1'
    if (forceLogin) return

    if (!isVisitorAccessEnabled(currentTheme?.visitor_access)) return

    setIsRedirecting(true)
    setVisitorMode(true)
    setCookie(VISITOR_MODE_COOKIE, 'true', {
      maxAge: VISITOR_COOKIE_MAX_AGE,
      path: '/',
      sameSite: 'lax',
    })

    router.replace('/bem-vindo')
  }, [
    currentTheme?.visitor_access,
    isAuthenticated,
    isAuthLoading,
    isThemeInitialized,
    router,
    searchParams,
    setVisitorMode,
  ])

  return isRedirecting
}
